import React from "react";
import { Grid, InputAdornment, Typography } from "@mui/material";
import FormTextField from "app/components/form-components/FormTextField";

function SalaryRange({
  control,
  setError,
  clearErrors,
  preloadedData,
  minimumSalary,
  maximumSalary
}) {
  return (
    <>
      <h3>Pay Range</h3>
      <Grid container spacing={3} alignItems={"center"}>
        <Grid item xs={12} md={6}>
          <FormTextField
            name="jp_minimum_salary"
            label="Minimum Pay Range (Yearly) *"
            defaultValue={preloadedData ? preloadedData.jp_minimum_salary : ""}
            helperText="Starting salary is required"
            control={control}
            fullWidth
            onBlur={() => {
              if (Number(minimumSalary) > Number(maximumSalary)) {
                setError("jp_minimum_salary", {
                  type: "manual",
                  message: "Minimum salary is greater than maximum salary"
                });
              } else {
                clearErrors("jp_minimum_salary");
              }
            }}
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormTextField
            control={control}
            name="jp_maximum_salary"
            defaultValue={preloadedData ? preloadedData.jp_maximum_salary : ""}
            helperText="Maximum salary is required"
            label="Maximum Pay Range (Yearly) *"
            fullWidth
            onBlur={() => {
              if (parseInt(minimumSalary, 10) > parseInt(maximumSalary, 10)) {
                setError("jp_maximum_salary", {
                  type: "manual",
                  message: "Maximum salary is less than minimum salary"
                });
              } else if (parseInt(maximumSalary) > 30000000) {
                setError("jp_maximum_salary", {
                  type: "manual",
                  message: "Maximum salary cannot be greater than 300,00,000"
                });
              } else {
                clearErrors("jp_maximum_salary");
                clearErrors("jp_minimum_salary");
              }
            }}
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>
            }}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default SalaryRange;
